import React, { useCallback, useState } from 'react';
import { PrimaryActionButton, BackButton } from '@facet-wealth/design';
import PropTypes from 'prop-types';
import CenteredActions from 'Views/Page/Content/Modal/Components/CenteredActions';
import ActionsRow from 'Components/ComponentLibrary/Atoms/Layout/ActionsRow';

/* This molecule needs some work with its imports to make it better will be addressed in facet-design-library update */
const WhatIfStepNavigator = ({
  onNext,
  onPrevious,
  children,
}) => {
  const [submitting, setSubmitting] = useState(false);
  const submit = useCallback(async (...args) => {
    try {
      setSubmitting(true);
      await onNext(...args);
      setSubmitting(false);
    } catch (err) {
      setSubmitting(false);
    }
  }, [onNext]);
  if (!(onNext || onPrevious)) {
    return null;
  }

  return (
    <CenteredActions>
      <ActionsRow>
        {onPrevious ? (
          <BackButton
            onClick={onPrevious}
            label="Go Back"
            test={'what-if-stepper-back-button'}
          />
        ) : null}
        {onNext ? (
          <PrimaryActionButton
            onClick={submit}
            loading={submitting}
            disabled={submitting}
            test={'what-if-stepper-continue-button'}
            label={children}
            isFullWidth
            size="lg"
          />
        ) : null}
      </ActionsRow>
    </CenteredActions>
  );
};

WhatIfStepNavigator.defaultProps = {
  onNext: null,
  onPrevious: null,
  children: 'Continue',
};

WhatIfStepNavigator.propTypes = {
  onNext: PropTypes.func,
  onPrevious: PropTypes.func,
  children: PropTypes.node,
};

export default WhatIfStepNavigator;
